(function () {
    $(document).ready(function() {
      "use strict";

      function goToByScroll(scrollTo) {
        $('html, body').animate({
          scrollTop: scrollTo.offset().top - 150
        }, 1000, function() {
          // Callback after animation
          // Must change focus!
          // var $target = scrollTo;
          // $target.focus();
          // if ($target.is(":focus")) { // Checking if the target was focused
          //   return false;
          // } else {
          //   $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
          //   $target.focus(); // Set focus again
          // }
        });
      }

      $(document.body).on('click', 'li.comments > a', function(e) {
        e.preventDefault();
        goToByScroll($('#conversations'));
        // document.querySelector('#conversations').scrollIntoView({
        //   behavior: 'smooth'
        // });
      });
    });
}) ();
